/*
 * Engravity: quantity price breaks, shared part (every page).
 *  - Helpers on window.EngravityPriceBreaks, used by engravity-price-breaks-product.js on product pages.
 *  - Cart: lines on the wrong break are swapped to the right one (same options and logo), counting the
 *    product's total in the cart, or each line alone for "(Same Logo)" breaks.
 *  Pack options such as "How Many Glasses?" are left alone.
 */
(function () {
  'use strict';

  var TIER_OPTION = /price\s*break|quantity\s*based\s*pricing/i;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var NOTE_KEY = 'egp-cart-note';

  // ---------- price breaks ----------
  // "1-11 Mugs" -> 1, "250+ Mugs" -> 250, "Qty of 1" -> 1, "Quantity of 25-50" -> 25, "1 Glass (Sample)" -> 1
  function tierMin(label) {
    var m = String(label).match(/(\d[\d,]*)/);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
  }

  // Each break runs up to one below the next break's minimum, so "1 Tumbler / 3+ / 6+" leaves no gaps.
  function tiersFor(values) {
    var list = [];
    for (var i = 0; i < values.length; i++) {
      var n = tierMin(values[i]);
      if (n === null) return null;
      list.push({ value: values[i], min: n });
    }
    if (list.length < 2) return null;
    list.sort(function (a, b) { return a.min - b.min; });
    list.forEach(function (t, i) { t.max = i + 1 < list.length ? list[i + 1].min - 1 : Infinity; });
    return list;
  }

  function tierForQty(tiers, qty) {
    var pick = tiers[0];
    tiers.forEach(function (t) { if (qty >= t.min) pick = t; });
    return pick;
  }

  function findTier(tiers, value) {
    for (var i = 0; i < tiers.length; i++) if (tiers[i].value === value) return tiers[i];
    return null;
  }

  function rangeText(t) {
    return t.max === Infinity ? t.min + '+' : (t.min === t.max ? String(t.min) : t.min + '–' + t.max);
  }

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]+>/g, '');
  }

  // ---------- styles and the customer note ----------
  function injectCss(id, css) {
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    document.head.appendChild(s);
  }

  var TOAST_CSS = '' +
    '.egp-toast{position:fixed;left:50%;bottom:24px;z-index:1000;max-width:min(92vw,460px);transform:translate(-50%,16px);opacity:0;visibility:hidden;' +
    'background:#1c1b1b;color:#fff;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.25);padding:12px 16px;font-size:14px;line-height:1.4;' +
    'transition:opacity .25s,transform .25s,visibility .25s}' +
    '.egp-toast.is-visible{opacity:1;visibility:visible;transform:translate(-50%,0)}';

  var toastTimer = 0;
  function showNote(text) {
    injectCss('egp-toast-style', TOAST_CSS);
    var el = document.querySelector('.egp-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'egp-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = text;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 7000);
  }

  // ---------- cart ----------
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var root = (window.routes && window.routes.rootUrl) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  function getJSON(path) {
    return nativeFetch(root + path, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  function postJSON(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  var products = {};
  function loadProduct(handle) {
    if (!products[handle]) products[handle] = getJSON('products/' + encodeURIComponent(handle) + '.js').catch(function () { return null; });
    return products[handle];
  }

  function hasTier(item) {
    return (item.options_with_values || []).some(function (o) { return TIER_OPTION.test(o.name); });
  }

  // Work out which lines sit on the wrong price break and which variant they belong on.
  function plan(items, byHandle) {
    var rows = [], totals = {};
    items.forEach(function (item) {
      var p = byHandle[item.handle];
      if (!p || !p.options) return;
      var idx = -1;
      p.options.forEach(function (o, i) { if (idx === -1 && TIER_OPTION.test(o.name || o)) idx = i; });
      if (idx === -1) return;
      var tiers = tiersFor(p.options[idx].values || []);
      var variant = p.variants.filter(function (v) { return v.id === item.variant_id; })[0];
      if (!tiers || !variant) return;
      var current = variant['option' + (idx + 1)];
      var key = /same\s*logo/i.test(current) ? 'line:' + item.key : 'product:' + item.product_id;
      totals[key] = (totals[key] || 0) + item.quantity;
      rows.push({ item: item, product: p, idx: idx, tiers: tiers, variant: variant, current: current, key: key });
    });

    var swaps = [];
    rows.forEach(function (r) {
      var total = totals[r.key];
      var want = tierForQty(r.tiers, total);
      if (want.value === r.current) return;
      var target = r.product.variants.filter(function (v) {
        for (var n = 1; n <= 3; n++) {
          var expected = n === r.idx + 1 ? want.value : r.variant['option' + n];
          if ((v['option' + n] || null) !== (expected || null)) return false;
        }
        return true;
      })[0];
      if (!target || target.available === false) return;
      swaps.push({ item: r.item, target: target, tier: want, total: total });
    });
    return swaps;
  }

  function applySwaps(swaps) {
    var chain = Promise.resolve();
    swaps.forEach(function (s) {
      chain = chain
        .then(function () { return postJSON('cart/add.js', { items: [{ id: s.target.id, quantity: s.item.quantity, properties: s.item.properties || {} }] }); })
        .then(function () { return postJSON('cart/change.js', { id: s.item.key, quantity: 0 }); });
    });
    return chain.then(function () { return swaps; });
  }

  function noteFor(swaps) {
    if (swaps.length === 1) {
      var s = swaps[0];
      return 'Price updated: ' + s.item.product_title + ' is now on the ' + rangeText(s.tier) + ' price break to match your quantity of ' + s.total + '.';
    }
    return 'Prices updated: ' + swaps.length + ' items were moved to the price break that matches the quantity in your cart.';
  }

  var busy = false, again = false, timer = 0;
  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkCart, 300);
  }

  function checkCart() {
    if (!nativeFetch) return;
    if (busy) { again = true; return; }
    busy = true;
    getJSON('cart.js')
      .then(function (cart) {
        var items = (cart.items || []).filter(hasTier);
        if (!items.length) return [];
        var handles = [];
        items.forEach(function (it) { if (handles.indexOf(it.handle) === -1) handles.push(it.handle); });
        return Promise.all(handles.map(loadProduct)).then(function (list) {
          var byHandle = {};
          handles.forEach(function (h, i) { byHandle[h] = list[i]; });
          return applySwaps(plan(items, byHandle));
        });
      })
      .then(function (done) {
        if (!done || !done.length) return;
        var note = noteFor(done);
        if (window.theme && window.theme.pageType === 'cart') {
          try { sessionStorage.setItem(NOTE_KEY, note); } catch (e) {}
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        showNote(note);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; scheduleCheck(); }
      });
  }

  // Watch every cart change the theme or an app makes (our own requests go through nativeFetch, so they don't loop).
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch(input, init);
      if (CART_WRITE.test(url)) p.then(scheduleCheck, function () {});
      return p;
    };
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.egpCartWrite = CART_WRITE.test(String(url));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.egpCartWrite) this.addEventListener('loadend', scheduleCheck);
      return send.apply(this, arguments);
    };
  }

  window.EngravityPriceBreaks = {
    TIER_OPTION: TIER_OPTION,
    tiersFor: tiersFor,
    tierForQty: tierForQty,
    findTier: findTier,
    rangeText: rangeText,
    money: money,
    injectCss: injectCss
  };

  function init() {
    try {
      var saved = sessionStorage.getItem(NOTE_KEY);
      if (saved) { sessionStorage.removeItem(NOTE_KEY); showNote(saved); }
    } catch (e) {}
    if (window.theme && window.theme.cartCount > 0) scheduleCheck();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();